import { getStorage, ref, uploadBytes, getDownloadURL, deleteObject } from "firebase/storage";
import uuid from 'react-native-uuid';

const uploadAsset = async (fileUri,folder) => {  
  try {
    const response = await fetch(fileUri);
    const blob = await response.blob();
    const storage = getStorage();
    const subFolder = !!folder ? folder : '';
    const storageRef = ref(storage, `/pottymouth${subFolder}/${uuid.v4()}`);

    return uploadBytes(storageRef, blob).then((snapshot) => { 
      return getDownloadURL(snapshot.ref).then((downloadURL) => {
        console.log(downloadURL);
        blob.close();
        return downloadURL;
      });
    });
  } catch (err) {
    console.log(err);
  }
}
const removeAsset = async (fileName, collection) => {
    const storage = getStorage();
    const desertRef = ref(storage, `${collection}/thisbit/${fileName}`);

    // Delete the file
    deleteObject(desertRef).then(() => {
      // File deleted successfully
    }).catch((error) => {
      // Uh-oh, an error occurred!
    });
}
export { uploadAsset, removeAsset };